<template>
  <div class="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex flex-wrap justify-content-between align-items-center">
            <img src="../assets/mc.png" alt="MasterCard" />
            <img src="../assets/skrill.png" alt="Skrill" />
            <img src="../assets/wire.png" alt="WireTransfer" />
            <img src="../assets/visa.png" alt="VISA" />
            <img src="../assets/neteller.png" alt="Neteller" />
          </div>
        </div>
      </div>
    </div>
    <div class="conteiner-fluid footer-bottom">
      <div class="row pb-5">
        <!-- 1 -->
        <div class="col-lg-2 col-md-2 col-md-2 col-12 offset-lg-2 offset-md-1 offset-0 footer-logo">
          <img src="../assets/logo.png" alt="TrioMarkets logo" />
        </div>
        <!-- 2 -->
        <div class="col-lg-2 col-md-2 col-sm-3 trioaddress">
          <ul>
            <li>{{license == 'eu' ? 'TrioMarkets head office:' : 'Registered Office:'}}</li>
            <li>{{license == 'eu' ? 'Centro Office 301' : 'The Core 62 Ebene'}}</li>
            <li>{{license == 'eu' ? 'Grigori Afxentiou 11' : 'Cybercity'}}</li>
            <li>{{license == 'eu' ? '4003 Limassol, Cyprus' : '72201, Mauritius'}}</li>
          </ul>
        </div>
        <!-- 3 -->
        <div class="col-lg-2 col-md-2 col-sm-3 col-12 triocontacts">
          <ul>
            <li>
              <i class="fa fa-phone mr-2 mb-2"></i>{{license == 'eu' ? '+357 25 030056' : '+442037699474'}}
            </li>
            <li v-if="license == 'eu'">
              <i class="fa fa-fax mr-2 mb-2"></i>+357 25 250310
            </li>
            <li>
              <i class="fa fa-envelope mr-2"></i> {{license == 'eu' ? 'info@triomarkets.eu' : 'info@triomarketsglobal.com'}}
            </li>
          </ul>
        </div>
        <!-- 4 -->
        <div class="col-lg-1 col-md-2 col-sm-3 col-12 triosocial">
          <div class="triosocial-sm">
            <i class="fa fa-facebook mr-4"></i>
            <i class="fa fa-linkedin mr-4"></i>
            <i class="fa fa-twitter mr-4"></i>
            <i class="fa fa-youtube-play"></i>
          </div>
          <div class="row pb-4">
            <i class="fa fa-facebook mr-4"></i>
            <i class="fa fa-linkedin"></i>
          </div>
          <div class="row">
            <i class="fa fa-twitter mr-4"></i>
            <i class="fa fa-youtube-play"></i>
          </div>
        </div>
        <!-- 5 -->
        <div class="col-lg-2 col-md-2 col-sm-3 col-12 triomenu">
          <ul>
            <li>
              <a
                :href="license == 'eu' ? 'https://triomarkets.eu/legal-documents/Client-Service-Agreement.pdf' : 'https://www.triomarkets.com/legal-documents/Benor_Capital_Ltd-Terms_of_Business.pdf'"
                target="_blank"
              >{{ translation.menuTerms }}</a>
            </li>
            <li>
              <a
                :href="license == 'eu' ? 'https://triomarkets.eu/legal-documents/Privacy-Policy.pdf' : 'https://www.triomarkets.com/legal-documents/Benor_Capital_Ltd-Privacy_Policy.pdf'"
                target="_blank"
              >{{ translation.menuPrivacy }}</a>
            </li>
            <li v-if="license == 'eu'">
              <a
                href="https://triomarkets.eu/legal-documents/Risk-Disclosure-Policy.pdf"
                target="_blank"
              >{{ translation.menuRisk }}</a>
            </li>
            <li v-if="license == 'eu'">
              <a
                :href="'https://triomarkets.eum/downloads/PRIIP_KIDS.zip'"
                target="_blank"
              >{{ translation.menuKids }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div
          class="col-lg-8 col-md-8 offset-lg-2 col-sm-12 col-12 offset-md-2 offset-0 text-justify"
        >
          <p>{{ license == 'eu' ? translation.textOne : translation.textOneGlobal }}</p>
          <p class="pt-2">{{ license == 'eu' ? translation.textTwo : translation.textTwoGlobal }}</p>
          <p class="text-center py-4">
            <a v-if="license == 'eu'" href="#">{{ translation.warning }}</a>
          </p>
          <p class="text-center pb-1" v-html="license == 'eu' ? translation.regianal : translation.regianalGlobal"></p>
          <p class="text-center" v-html="license == 'eu' ? translation.edr : translation.benor"></p>
          <div class="text-center pb-3">
            <small>&copy; {{ translation.copyright }}</small>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="(wind.width <= 1000 && wind.top <= 100)"
      class="disclaimer"
      style="position: fixed; width: 100%; bottom: 0; left: 0; padding: 3px; text-align: center; font-size: 10pt; color: #fff; background: #000; z-index: 998;"
    >{{ license == 'eu' ? translation.risk : translation.riskGlobal }}</div>
    <div
      v-if="wind.width > 1000"
      class="disclaimer"
      style="position: fixed; width: 100%; bottom: 0; left: 0; padding: 3px; text-align: center; font-size: 10pt; color: #fff; background: #000; z-index: 998;"
    >{{ license == 'eu' ? translation.risk : translation.riskGlobal }}</div>
  </div>
</template>

<script>
import Footer from "../translations/footer";
export default {
  name: "Footer",
  data() {
    return {
      license: location.host.includes('triomarkets.com') ? 'global' : 'eu',
      translation: new Footer(this.$route.name),
      wind: {
        width: window.innerWidth,
        height: window.innerHeight,
        top: 0
      }
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll(e){
      this.wind.top = e.target.documentElement.scrollTop
    }
  }
};
</script>

<style scoped lang="scss">
//colors
$payments-bg: #e9edf0;
$footer-bg: #000;
$youtube-bg: #f1141a;
$facebook-bg: #0e6fac;
$twitter-bg: #15b4c9;
$linkedin-bg: #338ff1;
$golden: #e7c68c;
$footer-text-color: #fff;

//sizes
$footer-font-size: 16px;

ul,
li {
  list-style: none;
}

p {
  font-size: $footer-font-size;
}

.row {
  margin: auto;
}

.footer-top {
  padding: 5px 0;
  background: $payments-bg;
}

.footer-bottom {
  background: $footer-bg;
  padding-top: 60px;
  padding-bottom: 10px;
  color: $footer-text-color;
  font-size: $footer-font-size;
  a {
    text-decoration: none;
    color: $golden;
  }
  .trioaddress {
    border-right: 1px #fff solid;
    @media screen and (min-width: 983px) {
      max-width: 14%;
    }
  }
  .triosocial {
    border-right: 1px #fff solid;
    i {
      padding: 12px;
      border-radius: 50%;
    }
    .fa-facebook {
      padding-right: 15px;
      padding-left: 15px;
      background-color: $facebook-bg;
    }
    .fa-linkedin {
      background-color: $linkedin-bg;
    }
    .fa-twitter {
      background-color: $twitter-bg;
    }
    .fa-youtube-play {
      background-color: $youtube-bg;
    }
  }
  .triomenu {
    li {
      padding-bottom: 5px;
      a {
        color: $footer-text-color;
        &::before {
          content: ">";
          margin-right: 5px;
          @media screen and (max-width: 768px) {
            content: "";
          }
        }
      }
    }
  }
}

a,
p,
li,
li a,
i {
  @media screen and (max-width: 1480px) {
    font-size: 0.9rem;
  }
  @media screen and (max-width: 1278px) {
    font-size: 0.8rem;
  }
  @media screen and (max-width: 983px) {
    font-size: 0.7rem;
  }
  @media screen and (max-width: 575px) {
    font-size: 1em;
  }
}
.footer-logo {
  @media screen and (max-width: 983px) {
    text-align: center;
  }
  img {
    @media screen and (max-width: 1480px) {
      max-width: 250px;
    }
    @media screen and (max-width: 1278px) {
      max-width: 200px;
    }
    @media screen and (max-width: 983px) {
      max-width: 150px;
      padding-bottom: 25px;
    }
    @media screen and (max-width: 575px) {
      max-width: 100%;
    }
  }
}

.trioaddress,
.triomenu,
.triocontacts {
  @media screen and (max-width: 575px) {
    text-align: center;
  }
}
.triosocial {
  @media screen and (max-width: 575px) {
    display: none;
  }
}
.triosocial-sm {
  @media screen and (min-width: 576px) {
    display: none;
  }
}
</style>
